// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AcademicInformation_section__SqDkX {
  width: 100%;
  padding: 0px 0;
  background-color: #ffffff;
}
.AcademicInformation_section--alt__Sb7bF {
  background-color: #f3f7ff;
  padding-bottom: 40px;
}

.AcademicInformation_word-cloud__k\\+c0m {
  border-radius: 10px;
  background-color: #ffffff;
  padding: 32px 16px;
  scroll-margin-top: 40px;
}

@media only screen and (max-width: 480px) {
  .AcademicInformation_section__SqDkX {
    padding: 24px 0;
  }
  .AcademicInformation_word-cloud__k\\+c0m {
    padding: 16px 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/AcademicInformation/AcademicInformation.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,cAAA;EACA,yBAAA;AACF;AACE;EACE,yBAAA;EACA,oBAAA;AACJ;;AAGA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;AAAF;;AAGA;EACE;IACE,eAAA;EAAF;EAGA;IACE,iBAAA;EADF;AACF","sourcesContent":[".section {\n  width: 100%;\n  padding: 0px 0;\n  background-color: #ffffff;\n\n  &--alt {\n    background-color: #f3f7ff;\n    padding-bottom: 40px;\n  }\n}\n\n.word-cloud {\n  border-radius: 10px;\n  background-color: #ffffff;\n  padding: 32px 16px;\n  scroll-margin-top: 40px;\n}\n\n@media only screen and (max-width: 480px) {\n  .section {\n    padding: 24px 0;\n  }\n\n  .word-cloud {\n    padding: 16px 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `AcademicInformation_section__SqDkX`,
	"section--alt": `AcademicInformation_section--alt__Sb7bF`,
	"word-cloud": `AcademicInformation_word-cloud__k+c0m`
};
export default ___CSS_LOADER_EXPORT___;
